import React, { Children, cloneElement } from 'react';
import styles from './CalendarModal.module.css';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

export function CalendarModalContent({ children }) {
  return <div className={styles.content}>{children}</div>;
}
export function CalendarModalField({ id, label, children }) {
  const control = Children.only(children);

  return (
    <div className={styles.formGroup}>
      <div className={styles.fieldRow}>
        <label className={styles.label} htmlFor={id}>{label}</label>
        {cloneElement(control, {
          id,
          className: joinClassNames(styles.input, control.props.className),
        })}
      </div>
    </div>
  );
}

export function CalendarModalCheckbox({ label, ...inputProps }) {
  return (
    <div className={styles.formGroup}>
      <label className={styles.checkboxLabel}>
        <input className={styles.checkbox} type="checkbox" {...inputProps} />
        {label}
      </label>
    </div>
  );
}

export function CalendarModalStatus({ children }) {
  return <p className={styles.statusText}>{children}</p>;
}

export function CalendarModalActions({ children }) {
  return <div className={styles.actions}>{children}</div>;
}

export function CalendarModalButton({ variant = 'default', className, ...buttonProps }) {
  return (
    <button
      type="button"
      className={joinClassNames(
        styles.actionButton,
        variant === 'danger' && styles.dangerButton,
        className
      )}
      {...buttonProps}
    />
  );
}
